/**
 * A Lib  for styled-components dependent on react-bootstrap
 * @todo These will have to be refactored to use standard html elements or another library
 * react-bootstrap@0.32.* is severely depreciated and will block us from migrating to v5.
 * @todo Review which of these are simple helper divs.
 */
import { Col, Button } from 'react-bootstrap'

import styled from 'styled-components'

export const StyledSearchButtonColumn = styled(Col)`
  padding-right: 0px;
  float: right;

  @media (max-width: 767px) {
    padding-right: 20px;
  }
`

export const StyledSearchIconButton = styled(Button)`
  border: none;
  background-color: transparent;
  padding: 0;
  height: 3rem;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 10px;
  margin-top: 5px;
  float: right;

  &:hover {
    background-color: transparent;
    font-size: var(--h5);
  }

  &:active:focus {
    background-color: transparent;
  }

  &:focus {
    background-color: transparent;
  }

  svg {
    fill: var(--clr-white-to-accent);
    cursor: pointer;
  }
`

export const StyledSelectDeviceButton =  styled(Button).attrs(props => ({
  id: props.id,
  className: 'animated fadeIn outlined'
}))`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: var(--clr-main-to-black);
  color: var(--clr-nav-text);
  border: none;
  font-weight: 700;
  letter-spacing: 0.05em;
  text-decoration: none;
  text-transform: uppercase;
  white-space: normal;
  border-radius: 0;
  overflow: hidden;
  padding: 0px 15px;
  height: var(--navHeight);
 
  svg {
    fill: var(--white);
    min-width: var(--small-icon-size);
    margin-right: 10px;
  }

  &:hover,
  &:focus {
    background-color: rgba(255, 255, 255, 0.25);
    color: var(--clr-nav-text);
  }

  &:active:focus {
    background-color: var(--clr-accent-to-black);
    color: var(--clr-nav-text);
  }
  @media (max-width: 991px) {
    width: 140px;
  }

  @media (max-width: 767px) {
    width: 100%;
  }
`

export const StyledRemoveDeviceText = styled.div`
  color: var(--clr-nav-text-to-accent);
  display: -webkit-box;
  -webkit-line-clamp: 2; /* number of lines to show */
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  line-height: 1.6;
  text-transform: none;
  font-weight: 700;
`

StyledSearchButtonColumn.displayName =
  'StyledSearchButtonColumnWithDepreciatedReactBootStrap'
StyledRemoveDeviceText.displayName =
  'StyledRemoveDeviceTextDivThatShouldBeASpanElement'
StyledSearchIconButton.displayName =
  'StyledSearchIconButtonWithDepreciatedReactBootStrap'
StyledSelectDeviceButton.displayName =
  'StyledSelectDeviceButtonWithDepreciatedReactBootStrap'



// WEBPACK FOOTER //
// ./src/components/SubHeader/styled/lib.js